<template>
  <div class="card-container">
    <!-- <div v-if="duringSubmit" class="loading">
      <Loading />
    </div> -->
    <card class="card-login card-white">

      <Header pageTitle="Register"></Header>
      <hr />
      <div class="container">
        <p style="text-align:center">Welcome to AGATRS Registration! </p>
        <p>
          Complete the registration information below for New Accounts. Ensure you enter your email address,
          organization, and approver correctly as it will be used to process your account request. If you are unsure of
          your approver, contact your organization to determine your ACSA PM. <br /></p>


        <p style="text-align:left"><a href="https://www.jccs.gov/HDPlus/Ext/App?Name=AGATRS">Already have an account?
          </a> For modifications to existing accounts, questions, and additional support, please submit a HelpDesk
          ticket by selecting the HelpDesk & Feedback button at the bottom of any AGATRS page.</p><br />
      </div>


      <fieldset>
        <legend>Basic Information </legend>
        <div class="row">
          <div class="col-md-6">
            <label for="FirstName">First Name:</label>
            <base-input id="FirstName" v-validate="'required'" leftLabel="*" leftLabelColor="#C00000"
              :error="getError('firstName')" v-model="firstName" name="firstName" data-vv-as="First Name" type="text"
              placeholder="First name" addon-left-icon="tim-icons icon-single-02"></base-input>
          </div>
          <div class="col-md-6">
            <label for="LastName">Last Name:</label>
            <base-input id="LastName" v-validate="'required'" leftLabel="*" leftLabelColor="#C00000"
              :error="getError('lastName')" v-model="lastName" name="lastName" data-vv-as="Last Name" type="text"
              placeholder="Last name" addon-left-icon="tim-icons icon-single-02"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="Title">Title:</label>
            <base-input id="Title" leftLabel="*" leftLabelColor="transparent" :error="getError('title')" v-model="title"
              name="title" type="text" placeholder="Title" addon-left-icon="tim-icons icon-badge"></base-input>
          </div>
          <div class="col-md-6">
            <label for="PhoneNumber">Phone Number: </label>
            <div class="phone-field">
              <base-phone-input
                leftLabelColor="red"
                :error="getError('phoneNumber')"
                leftLabel="*"
              >
                <vue-tel-input
                  v-model="phoneNumberTemp"
                  :preferredCountries="['US']"
                  defaultCountry="US"
                  mode="international"
                  validCharactersOnly
                  :inputOptions="{ placeholder: '(xxx)xxxxxxxxx', styleClasses: 'form-control' }"
                  @validate="onPhoneValidate"
                />
              </base-phone-input>     
            </div>
          </div>
        </div>
        <label for="Email">Email:</label>
        <base-input id="Email" v-validate="'required|email'" leftLabel="*" leftLabelColor="#C00000" v-model.trim="email"
          name="email" placeholder="Email" addon-left-icon="tim-icons icon-email-85"></base-input>
        <span v-show="errors.has('email')" class="error">
          Email should be a valid government email
        </span>
        <br>
        <div class="text-left black">
          <ul>
            <li>Minimum password length 15 characters.</li>
            <li>
              Password must include at least 1:
              <br />Uppercase, Lowercase, Number, and Special Character
            </li>
            <li>
              Allowed Special Characters (! @ # $ % ^ & * ( ) _ + = - [ ] / ?)
            </li>
          </ul>
        </div>
        <label for="password">Password:</label>
        <div class="password-input">
          <base-input id="password"
            v-validate="{ required: true, regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+\=\-\[\]/?]).{8,}$/ }"
            leftLabel="*" leftLabelColor="#C00000" v-model="password" name="password" data-vv-as="password" ref="password"
            :type="showPassword ? 'text' : 'password'" placeholder="Password" addon-left-icon="tim-icons icon-lock-circle">
          </base-input>
          <button type="button" class="password-toggle-btn" @click="showPassword = !showPassword" @mousedown.prevent>
            <i :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
          </button>
        </div>
        <span class="error" v-if="password.length > 0" v-for="(message, index) in passwordErrors.slice(0, 1)" :key="index">{{
          `${getError('password') ?
            getError('password') : message }` }}</span> <br />
        <label for="confirmPassword">Confirm Password:</label>
        <div class="password-input">
          <base-input id="confirmPassword" v-validate="'required|confirmed:password'" leftLabel="*"
            leftLabelColor="#C00000" :error="getError('confirmPassword')" v-model="confirmPassword"
            data-vv-as="confirm password" name="confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm password"
            addon-left-icon="tim-icons icon-lock-circle">
          </base-input>
          <button type="button" class="password-toggle-btn" @click="showConfirmPassword = !showConfirmPassword" @mousedown.prevent>
            <i :class="showConfirmPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
          </button>
        </div>
      </fieldset>

      <fieldset>
        <legend>Account Information</legend>
        <label for="Organization">Organization:</label>
        <base-input class="treeselect-wrapper" :error="getError('organization')" aria-label="Organization">
          <div class="required_input_grid">
            <div class="grid_column_1 grid_center_item input_field_text color_red">
              *
            </div>
            <treeselect v-model="organizationId" class="select-primary" name="organization" v-validate="'required'"
              :multiple="false" :searchable="true" :disabled="false" :open-on-click="true" :open-on-focus="false"
              :clear-on-select="false" :close-on-select="true" :always-open="false" :append-to-body="false"
              search-nested :options="jointStaffOrganizations" placeholder="Organization" :clearable="true"
              :default-expand-level="1"
              @input="filterApprover(organizationId)" />
          </div>
        </base-input>
        <base-input :error="getError('approver')">
          <label for="Approver">Approver:</label>
          <div class="required_input_grid">
            <div class="grid_column_1 grid_center_item input_field_text color_red">
              *
            </div>
            <v-select class="style-chooser" id="approverInput" v-model="approverId" name="approver"
              v-validate="'required'" :reduce="(user) => user.id" label="name" :options="approvers"
              placeholder="Approver"></v-select>
          </div>
        </base-input>
      </fieldset>
      <fieldset>
        <register-files v-bind:initialDocumentArr="requiredDocmentTypes" v-bind:submittedTypes="submittedTypes">
        </register-files>
      </fieldset>
      <fieldset>
        <user-upload v-on:userFileUpload="handleFileUpload" v-on:fileDelete="handleFileDelete"
          ref="uploadModal"></user-upload>
      </fieldset >
     
      <fieldset class="align-center more-top-padding">
          <base-button @click="submit" :disabled="isDisabled" class="btn grid_center_item" type="primary"
          v-b-popover.hover.bottom="'Register for AGATRS!'">
          <i class="tim-icons icon-send"></i> Request AGATRS Access
        </base-button>
      </fieldset>
       <fieldset class="align-center more-top-padding">
         <router-link class="button" to="/Login" v-b-popover.hover.bottom="'Login to AGATRS using your username/password or using your CAC.'
          ">
          Already have an account?
        </router-link>
        </fieldset>
    </card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/App/Header";
import Treeselect from "@riophae/vue-treeselect";
import { Select, Option, Divider, Checkbox } from "element-ui";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import Utility from "@/mixins/utility/utility";
import Loading from 'src/components/LoadingPanel';
import UserUpload from "../components/UserFilesUpload";
import RegisterFiles from "../components/RegisterDocumentList";
import BasePhoneInput from '../components/Inputs/BasePhoneInput.vue';

export default {
  name: "Register",
  components: {
    Header,
    [Select.name]: Select,
    [Option.name]: Option,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    Treeselect,
    Loading,
    UserUpload,
    RegisterFiles,
    BasePhoneInput
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      title: "",
      phoneNumber: "",
      phoneNumberTemp: "",
      // emailInformation: true,
      email: "",
      password: "",
      confirmPassword: "",
      organizationId: null,
      approverId: null,
      registerErrorMessage: "",
      file: null,
      remark: null,
      disabled: false,
      approvers: [],
      authorizedAs: [],
      duringSubmit: false,
      submittedTypes: [],
      requiredDocmentTypes: [],
      phoneValid: false,
      phoneE164: '',
      userFilesForSubmission: [],
      showPassword: false,
      showConfirmPassword: false
    };
  },
  mixins: [Utility],
  mounted() {
    this.getJointStaffOrganizations();
    this.getSponsorUsers(false);
    this.updateAriaLabels();
    this.requiredDocmentTypes.push({
      name: "TRAINING CERTIFIED",
      added: false
    });
    this.requiredDocmentTypes.push({
      name: "APPOINTMENT MEMO",
      added: false
    });
    const dict = {
      custom: {
        password: {
          regex: this.passwordErrors,
          required: "Password is Required"
        },
        phoneNumber: {
          regex: "Please enter a Valid Phone number",
          required: "Phone Number is Required"
        },
        firstName: {
          required: "First Name is required"
        },
        lastName: {
          required: "Last Name is required"
        }
      }
    }
    this.$validator.localize('en', dict);
    this.getAllCountryTwoCharacterCode(false);
  },
  computed: {
    ...mapGetters({
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      organization: "organization/organization",
      sponsorUsers: "users/sponsorUsers",
      countryTwoCharacterCodes: "countries/countryTwoCharacterCodes"
    }),
    passwordErrors() {
      const errors = [];
      if (this.password.length < 15) {
        errors.push('Password should contain at least 15 characters.')
      }
      if (!/[A-Z]/.test(this.password)) {
        errors.push('Password should contain at least 1 upper case letter.')
      }
      if (!/[a-z]/.test(this.password)) {
        errors.push('Password should contain at least 1 lower case letter.')
      }
      if (! /\d/.test(this.password)) {
        errors.push('Password should contain at least 1 number.')
      }
     const regex = /[!@#$%^&*()_+\=\-\[\]\/\?,]/;
      if (!regex.test(this.password)) {
        // If the password does not contain a special character, add an error message
        errors
          .push("Password should contain at least 1 special character. !@#$%^&*()_+=-[]/?")
      }
      return errors;
    },
    isDisabled() {
      return this.disabled;
    },
    authorizedAsLogistics() {
      return this.authorizedAs.includes("Logistics");
    },
    authorizedAsFinance() {
      return this.authorizedAs.includes("Finance");
    },
  },
  watch: {
    phoneNumberTemp(val) {
      if (!val) {
        this.errors.add({ field: 'phoneNumber', msg: 'Phone Number is required' });
      }
    },
  },
  methods: {
    ...mapActions({
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getOrganization: "organization/getOrganization",
      getSponsorUsers: "users/getSponsorUsers",
      register: "authentication/register",
      getAllCountryTwoCharacterCode: "countries/getAllCountryTwoCharacterCode"
    }),
    updateAriaLabels() {
      const organizationInput = document.querySelector("input.vue-treeselect__input[type='text']");
      const approverInput = document.querySelector("#approverInput .vs__dropdown-toggle");
      organizationInput.setAttribute("aria-label", "Select Organization");
      approverInput.setAttribute("aria-label", "Select Approver");
    },
    onPhoneValidate(phoneObject) {
      this.phoneValid = phoneObject.valid;
      this.phoneE164 = phoneObject.number ? (phoneObject.number.e164 || phoneObject.number.international || '') : '';
      if (!phoneObject.valid && this.phoneNumberTemp) {
        this.errors.add({ field: 'phoneNumber', msg: 'Please enter a valid phone number' });
      } else {
        this.errors.remove('phoneNumber');
      }
    },
    async filterApprover(organizationId) {
      this.approvers = [];
      this.approverId = null;
      if (!organizationId) return;

      while (this.approvers.length <= 0) {
        // set the users
        this.approvers = this.sponsorUsers.filter(f => f.organizationId === organizationId);
        // get the parent just incase
        await this.getOrganization(organizationId);

        // break out if parent is joint staff
        if (this.organization.parentId === 48 && this.organization.organizationId !== 48) break;

        organizationId = this.organization.parentId;

        // break out if we've reached the root (no parent)
        if (!organizationId) break;
      }
    },
    getError(fieldName) {
      return Util.makeTextSentenceLowerCase(this.errors.first(fieldName));
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },
    onCancelClicked() {
      this.$router.push({
        name: "Login",
      });
    },
    handleFileDelete() {
      this.submittedTypes = this.$refs['uploadModal'].getFileTypes();
    },
    handleFileUpload(processedDocument) {
      // Ensure 'processedDocument' contains required properties.
      if (!processedDocument?.file) {
        this.$toast.error("File upload failed: No file data received.");
        console.error("Register.vue - handleFileUpload: Missing file data.", processedDocument);
        return;
      }

      // Validate file type object.
      if (!processedDocument.type?.name) {
        this.$toast.error("File upload failed: Invalid file type data.");
        console.error("Register.vue - handleFileUpload: Invalid file type.", processedDocument);
        return;
      }

      // Verify allowed file formats.
      if (!Util.isSupportedFile(processedDocument.file.name, /\.(jpg|jpeg|png|pdf)$/i)) {
        this.$toast.error("Invalid File Type (caught in Register.vue)!");
        return;
      }

      // UserFilesUpload has already added and processed the file; update submission state.
      this.submittedTypes = this.$refs['uploadModal'].getFileTypes();

      // Safety: ensure the array is initialized (guards against stale builds)
      if (!Array.isArray(this.userFilesForSubmission)) {
        this.userFilesForSubmission = [];
      }
      this.userFilesForSubmission.push(processedDocument);

      // Avoid modifying UserFilesUpload's internal state.
      // DO NOT call: this.$refs['uploadModal'].addFiles(); or this.$refs['uploadModal'].clearDocument(true);
    },
    async submit() {
      let ctx = this;
      if (this.submittedTypes.length === 0) {
        this.$toast.error("Required documents must be added");
        return;
      }
      // check if all requried file types have uploaded
      let missingFileTypes = [];
      for (let i = 0; i < this.requiredDocmentTypes.length; i++) {
        let f = this.requiredDocmentTypes[i];
        let r = this.submittedTypes.find(d => d === f.name);
        if (r === undefined) {
          missingFileTypes.push(f.name);
        }
      }
      if (missingFileTypes.length > 0) {
        this.$toast.error(`Missing file type ${missingFileTypes.join(',')}`);
        return;
      }
      let isValid = ctx.$validator.validateAll();//.then((isValid) => {
      if (isValid) {
        let files = this.$refs['uploadModal'].getFiles();
        ctx.duringSubmit = true;
        let formData = new FormData();

        // get phone number formatted to only numbers
        this.phoneNumber = '';
        if (!this.phoneValid) {
          this.$toast.error(`Phone Number: Please enter a valid phone number`);
          this.$loaderApp.completeRequest();
          return;
        }
        this.phoneNumber = this.phoneE164 ? this.phoneE164.replace(/\D/g, '') : this.phoneNumberTemp.replace(/\D/g, '');
        // add file and file types one by one
        let f = files.map(a => a.file);
        for (let i = 0; i < f.length; i++) {
          formData.append('iFiles.iFiles', f[i]);
        }
        for (let i = 0; i < this.submittedTypes.length; i++) {
          formData.append('iFiles.fileTypes', this.submittedTypes[i]);
        }
        formData.append("firstName", ctx.firstName);
        formData.append("lastName", ctx.lastName);
        formData.append("title", ctx.title);
        formData.append("phoneNumber", ctx.phoneNumber);
        formData.append("email", ctx.email);
        formData.append("password", ctx.password);
        formData.append("isNotPartnerNation", true);
        formData.append("confirmPassword", ctx.confirmPassword);
        formData.append("organizationId", ctx.organizationId);
        formData.append("approverId", ctx.approverId);
        formData.append("file.remark", '');

        try {
        ctx.disabled = true;
        ctx.$loaderApp.addRequest();
          await ctx.register(formData);
          this.$loaderApp.completeRequest();
          ctx.disabled = false
          ctx.$router.replace({
            name: "RegisterConfirmation",
          });

        } catch (err) {
          ctx.disabled = false;
          this.$loaderApp.completeRequest();
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el_date input,
.el_date .el-input__inner,
input,
.input-group-text,
.vue-treeselect__control,
.vs__dropdown-toggle {
  border-left: none !important;
  border-top: none !important;
  border-right: none !important;
  border-radius: 0 !important;
  line-height: 2 !important;
}

.input-group-text {
  padding-right: 5px !important;
}

.form-group input[type="file"] {
  opacity: inherit;
  position: inherit;
  top: inherit;
  right: inherit;
  bottom: inherit;
  left: inherit;
  width: inherit;
  height: inherit;
  z-index: inherit;
}

.loading {
  position: absolute;
  width: inherit;
  height: auto;
  background-color: lightblue;
}

.remark-box {
  border: solid 1px #525f7f;
  padding-left: 10px;
}

// Shared treeselect arrow styles (AGATRS green)
@import '../assets/sass/dashboard/custom/registration-treeselect';

// Hide the validation X icon (has-danger::after) on treeselect form-groups
// by removing the positioning context so the absolute-positioned icon doesn't render
::v-deep .treeselect-wrapper.form-group {
  position: static !important;
}

// .phone-field {
//   display: flex;
//   flex-direction: row;
//   justify-content: start;
//   gap: 0px;
//   #vcd {
//     margin-bottom: 10px !important;
//     border-radius: 3px !important;
//     flex: 1
//   };
//   #PhoneNumber {
//     border-left: none !important;
//     flex: 2
//   }
// }

// .phone-field > * {
//   flex: 1 100%;
// }</style>
